module.exports = __webpack_public_path__ + "static/media/CarryOn_Backpack_Arrows.3745ee1a.glb";